import { createFileRoute } from '@tanstack/react-router'

import RecentUsers from 'pages/RecentUsers'

export const Route = createFileRoute('/_auth/_global/recent-users')({
  component: RecentUsers,
})
